{
  "counters": {
    "u_row": 2,
    "u_column": 2,
    "u_content_html": 1,
    "u_content_text": 5,
    "u_content_button": 1,
    "u_content_social": 1
  },
  "body": {
    "rows": [
      {
        "cells": [
          1
        ],
        "columns": [
          {
            "contents": [
              {
                "type": "text",
                "values": {
                  "containerPadding": "10px",
                  "textAlign": "center",
                  "lineHeight": "140%",
                  "linkStyle": {
                    "inherit": true,
                    "linkColor": "#0000ee",
                    "linkHoverColor": "#0000ee",
                    "linkUnderline": true,
                    "linkHoverUnderline": true
                  },
                  "hideDesktop": false,
                  "_meta": {
                    "htmlID": "u_content_text_1",
                    "htmlClassNames": "u_content_text"
                  },
                  "selectable": true,
                  "draggable": true,
                  "duplicatable": true,
                  "deletable": true,
                  "hideable": true,
                  "text": "<p style=\"font-size: 14px; line-height: 140%;\"><strong><span style=\"font-family: arial, helvetica, sans-serif; font-size: 32px; line-height: 44.8px;\">Bedankt voor je bestelling!</span></strong></p>\n<p style=\"font-size: 14px; line-height: 140%;\">Beste {klant_naam},</p>\n<p style=\"font-size: 14px; line-height: 140%;\">&nbsp;</p>\n<p style=\"font-size: 14px; line-height: 140%;\">Bedankt voor je bestelling bij {bedrijf_naam} via bol!</p>\n<p style=\"font-size: 14px; line-height: 140%;\">&nbsp;</p>\n<p style=\"font-size: 14px; line-height: 140%;\">In de bijlage vind je de BTW factuur van jouw bestelling.</p>\n<p style=\"font-size: 14px; line-height: 140%;\">&nbsp;</p>\n<p style=\"font-size: 14px; line-height: 140%;\">Mocht je nog eens vragen hebben, neem dan gerust contact met ons op!</p>\n<p style=\"font-size: 14px; line-height: 140%;\">&nbsp;</p>\n<p style=\"font-size: 14px; line-height: 140%;\">Met vriendelijke groet,</p>\n<p style=\"font-size: 14px; line-height: 140%;\">&nbsp;</p>\n<p style=\"font-size: 14px; line-height: 140%;\">{bedrijf_naam}</p>"
                }
              }
            ],
            "values": {
              "_meta": {
                "htmlID": "u_column_1",
                "htmlClassNames": "u_column"
              },
              "border": {},
              "padding": "0px 10px",
              "backgroundColor": "#ffffff"
            }
          }
        ],
        "values": {
          "displayCondition": null,
          "columns": false,
          "backgroundColor": "",
          "columnsBackgroundColor": "",
          "backgroundImage": {
            "url": "",
            "fullWidth": true,
            "repeat": false,
            "center": true,
            "cover": false
          },
          "padding": "30px 0px 0px",
          "hideDesktop": false,
          "_meta": {
            "htmlID": "u_row_1",
            "htmlClassNames": "u_row"
          },
          "selectable": true,
          "draggable": true,
          "duplicatable": true,
          "deletable": true,
          "hideable": true
        }
      },
      {
        "cells": [
          1
        ],
        "columns": [
          {
            "contents": [
              {
                "type": "text",
                "values": {
                  "containerPadding": "10px",
                  "color": "#999999",
                  "textAlign": "center",
                  "lineHeight": "140%",
                  "linkStyle": {
                    "inherit": true,
                    "linkColor": "#0000ee",
                    "linkHoverColor": "#0000ee",
                    "linkUnderline": true,
                    "linkHoverUnderline": true
                  },
                  "hideDesktop": false,
                  "_meta": {
                    "htmlID": "u_content_text_5",
                    "htmlClassNames": "u_content_text"
                  },
                  "selectable": true,
                  "draggable": true,
                  "duplicatable": true,
                  "deletable": true,
                  "hideable": true,
                  "text": "<p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 12px; line-height: 16.8px;\">Verzonden via Bluemate</span></p>"
                }
              }
            ],
            "values": {
              "_meta": {
                "htmlID": "u_column_2",
                "htmlClassNames": "u_column"
              },
              "border": {},
              "padding": "0px",
              "borderRadius": "0px",
              "backgroundColor": ""
            }
          }
        ],
        "values": {
          "displayCondition": null,
          "columns": false,
          "backgroundColor": "",
          "columnsBackgroundColor": "",
          "backgroundImage": {
            "url": "",
            "fullWidth": true,
            "repeat": false,
            "center": true,
            "cover": false
          },
          "padding": "0px",
          "hideDesktop": false,
          "_meta": {
            "htmlID": "u_row_2",
            "htmlClassNames": "u_row"
          },
          "selectable": true,
          "draggable": true,
          "duplicatable": true,
          "deletable": true,
          "hideable": true
        }
      }
    ],
    "values": {
      "textColor": "#000000",
      "backgroundColor": "#fafafa",
      "backgroundImage": {
        "url": "",
        "fullWidth": true,
        "repeat": false,
        "center": true,
        "cover": false
      },
      "contentWidth": "500px",
      "contentAlign": "center",
      "fontFamily": {
        "label": "Arial",
        "value": "arial,helvetica,sans-serif"
      },
      "preheaderText": "",
      "linkStyle": {
        "body": true,
        "linkColor": "#0000ee",
        "linkHoverColor": "#0000ee",
        "linkUnderline": true,
        "linkHoverUnderline": true
      },
      "_meta": {
        "htmlID": "u_body",
        "htmlClassNames": "u_body"
      }
    }
  },
  "schemaVersion": 6
}